import { render, staticRenderFns } from "./StGallery.vue?vue&type=template&id=a42df7c2"
import script from "./StGallery.vue?vue&type=script&lang=ts"
export * from "./StGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports